"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _headless = _interopRequireDefault(require("@tippyjs/react/headless"));

var _tooltip = _interopRequireDefault(require("./tooltip.style"));

var _tooltipPointer = _interopRequireDefault(require("./tooltip-pointer.style"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags/tags"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TOOLTIP_DELAY = 100;

const Tooltip = /*#__PURE__*/_react.default.forwardRef(({
  children,
  isVisible,
  position = "top",
  message,
  type,
  size = "medium",
  isPartOfInput,
  inputSize,
  id,
  bgColor,
  fontColor,
  flipOverrides,
  ...rest
}, ref) => {
  const tooltipRef = (0, _react.useRef)(ref || null);

  const tooltip = (attrs, content) => {
    const currentPosition = attrs["data-placement"] || position;
    return /*#__PURE__*/_react.default.createElement(_tooltip.default, _extends({
      "data-element": "tooltip",
      role: "tooltip",
      tabIndex: "-1",
      type: type,
      size: size,
      id: id
    }, (0, _tags.default)("tooltip", rest), {
      isPartOfInput: isPartOfInput,
      inputSize: inputSize
    }, attrs, {
      position: currentPosition,
      ref: tooltipRef,
      bgColor: bgColor,
      fontColor: fontColor
    }), /*#__PURE__*/_react.default.createElement(_tooltipPointer.default, _extends({
      key: "pointer",
      type: type
    }, attrs, {
      position: currentPosition,
      "data-popper-arrow": "",
      "data-element": "tooltip-pointer",
      bgColor: bgColor
    })), /*#__PURE__*/_react.default.createElement("div", null, content));
  };

  return /*#__PURE__*/_react.default.createElement(_headless.default, _extends({
    placement: position,
    delay: TOOLTIP_DELAY
  }, isVisible !== undefined && {
    visible: isVisible
  }, {
    render: attrs => tooltip(attrs, message),
    popperOptions: {
      modifiers: [...(flipOverrides ? [{
        name: "flip",
        options: {
          fallbackPlacements: flipOverrides
        }
      }] : []), {
        name: "computeStyles",
        options: {
          gpuAcceleration: false
        }
      }]
    }
  }), children);
});

const placements = ["top", "bottom", "left", "right"];
Tooltip.propTypes = {
  /** The message to be displayed within the tooltip */
  message: _propTypes.default.node.isRequired,

  /** The id attribute to use for the tooltip */
  id: _propTypes.default.string,

  /** Whether to to show the Tooltip */
  isVisible: _propTypes.default.bool,

  /** Sets position of the tooltip */
  position: _propTypes.default.oneOf(placements),

  /** Defines the message type */
  type: _propTypes.default.string,

  /** Children elements */
  children: _propTypes.default.node.isRequired,

  /** Defines the size of the tooltip content */
  size: _propTypes.default.oneOf(["medium", "large"]),

  /** Override background color of the Tooltip, provide any color from palette or any valid css color value. */
  bgColor: _propTypes.default.string,

  /** Override font color of the Tooltip, provide any color from palette or any valid css color value. */
  fontColor: _propTypes.default.string,

  /** @ignore @private */
  isPartOfInput: _propTypes.default.bool,

  /** @ignore @private */
  inputSize: _propTypes.default.oneOf(["small", "medium", "large"]),

  /** Overrides the default flip behaviour of the Tooltip, must be an array containing some or all of ["top", "bottom", "left", "right"] (see https://popper.js.org/docs/v2/modifiers/flip/#fallbackplacements) */
  flipOverrides: (props, propName) => {
    const prop = props[propName];
    const isValid = prop && Array.isArray(prop) && prop.every(placement => placements.includes(placement));

    if (!prop || isValid) {
      return null;
    }

    return new Error( // eslint-disable-next-line max-len
    `The \`${propName}\` prop supplied to \`Tooltip\` must be an array containing some or all of ["top", "bottom", "left", "right"].`);
  }
};
var _default = Tooltip;
exports.default = _default;